"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramsMap = void 0;
const types_1 = require("../types");
exports.paramsMap = {
    [types_1.Currency.BTC]: {
        initialMarginStart: 0.02,
        maintenanceMarginStart: 0.01,
        marginIncrement: 0.00005,
        futureContingency: 0.006,
        volatilityRangeUp: 0.45,
        volatilityRangeDown: -0.3,
        ivMoves: [
            -0.17, -0.136, -0.102, -0.068, -0.034, 0, 0.034, 0.068, 0.102, 0.136,
            0.17,
        ],
        initialMarginFactor: 1.3,
    },
    [types_1.Currency.ETH]: {
        initialMarginStart: 0.02,
        maintenanceMarginStart: 0.01,
        marginIncrement: 0.000004,
        futureContingency: 0.009,
        volatilityRangeUp: 0.45,
        volatilityRangeDown: -0.3,
        ivMoves: [
            -0.17, -0.136, -0.102, -0.068, -0.034, 0, 0.034, 0.068, 0.102, 0.136,
            0.17,
        ],
        initialMarginFactor: 1.3,
    },
    // Linears
    [types_1.Currency.XRP]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000000045,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.SOL]: {
        initialMarginStart: 0.1,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000005,
        futureContingency: 0.01,
        volatilityRangeUp: 0.5,
        volatilityRangeDown: -0.4,
        ivMoves: [-0.2, -0.16, -0.12, -0.08, -0.04, 0, 0.04, 0.08, 0.12, 0.16, 0.2],
        initialMarginFactor: 1.5,
    },
    [types_1.Currency.ADA]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.00000006,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.ALGO]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000000045,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.BNB]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000005,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.AVAX]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000005,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.BCH]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000005,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.DOT]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.DOGE]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.00000002,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.LINK]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.LTC]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000005,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.MATIC]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.00000006,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.TRX]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.00000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.UNI]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.SHIB]: {
        initialMarginStart: 0.04,
        maintenanceMarginStart: 0.02,
        marginIncrement: 0.0000000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.BTCDVOL]: {
        initialMarginStart: 0.1,
        maintenanceMarginStart: 0.05,
        marginIncrement: 0.0000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
    [types_1.Currency.ETHDVOL]: {
        initialMarginStart: 0.1,
        maintenanceMarginStart: 0.05,
        marginIncrement: 0.0000001,
        futureContingency: 0,
        volatilityRangeUp: 0,
        volatilityRangeDown: 0,
        ivMoves: [],
        initialMarginFactor: 1.2,
    },
};
